import JobCreatePage from '@/pages/jobs/create'
import { WorkspacePortalProvider } from '@/contexts/workspace-portal-context'

export default function EventCreatePage() {
  return (
    <WorkspacePortalProvider mode="event">
      <JobCreatePage />
    </WorkspacePortalProvider>
  )
}
